module.exports = __webpack_public_path__ + "static/media/IEEE.42380c0a.png";